import React from "react";
import { useAccount } from 'wagmi';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { Tooltip } from 'react-tooltip';
import { Web3Button } from "@web3modal/react";




export const Connect = function () {
    const { address, isConnected } = useAccount()
    const { open } = useWeb3Modal()


    return (
        <React.Fragment>

            <>
                {address && isConnected ? (
                    <Web3Button data-tooltip-id="connect-wallet" data-tooltip-content="⚠️ Wallet connection is for platform access only. No financial transactions involved." />
                ) : (
                    <button data-tooltip-id="connect-wallet" data-tooltip-content="⚠️ Wallet connection is for platform access only. No financial transactions involved." type="button" className="connect-btn btn btn-connect" onClick={() => open()}>
                        Connect Wallet
                    </button>
                )
                }

                <Tooltip id="connect-wallet" />

            </>

        </React.Fragment >
    );
};

export default Connect;